import { render, staticRenderFns } from "./BaseConfigComponent.vue?vue&type=template&id=27c34b81&scoped=true&"
import script from "./BaseConfigComponent.vue?vue&type=script&lang=js&"
export * from "./BaseConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c34b81",
  null
  
)

export default component.exports